import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { LandingComponent } from './pages/landing/landing.component';
import { HomeComponent } from './pages/home/home.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SignoutComponent } from './pages/signout/signout.component';
import { AuthorizationComponent } from './pages/authorization/authorization.component';
import { CheckoutSuccessComponent } from './pages/checkout-success/checkout-success.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { AiChatComponent } from './components/ai-chat/ai-chat.component';

import { AuthInterceptor } from '../app/interceptors/auth.interceptor';
import {
  AuthGuardService,
  NoAuthGuardService,
  ValidSubscription,
  LandingRedirectGuard,
} from './services/auth-guard.service';
import { AuthenticationService } from './services/authentication.service';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    HomeComponent,
    SignInComponent,
    SignUpComponent,
    PricingComponent,
    ContactComponent,
    SignoutComponent,
    AuthorizationComponent,
    CheckoutSuccessComponent,
    ToastContainerComponent,
    AiChatComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgbToastModule,
    SharedModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthenticationService) => () => auth.initialize(),
      deps: [AuthenticationService],
      multi: true,
    },
    AuthGuardService,
    NoAuthGuardService,
    ValidSubscription,
    LandingRedirectGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
